export default {
  pt: {
    'hospedagem.title': 'Hospedagem',
    'hospedagem.eyebrow': 'Jornada',
    'hospedagem.kpi.hotels': 'Hotéis',
    'hospedagem.kpi.activeOperators': 'Operadores hospedados',
    'hospedagem.kpi.openIndividual': 'Individuais em aberto',
    'hospedagem.kpi.openShared': 'Compartilhados em aberto',
    'hospedagem.kpi.checkoutAlerts': 'Previsões de check-out vencidas',
    'hospedagem.kpi.openObservations': 'Observações em aberto',
    'hospedagem.filters.toggle': 'Filtros',
    'hospedagem.filters.clear': 'Limpar',
    'hospedagem.filters.hotel': 'Hotel',
    'hospedagem.filters.city': 'Cidade',
    'hospedagem.filters.operator': 'Operador',
    'hospedagem.filters.customer': 'Cliente',
    'hospedagem.filters.roomType': 'Tipo de quarto',
    'hospedagem.filters.roomStatus': 'Status do quarto',
    'hospedagem.filters.hotelStatus': 'Status do hotel',
    'hospedagem.filters.checkoutAlert': 'Alerta de check-out',
    'hospedagem.filters.alertWith': 'Com previsão vencida',
    'hospedagem.filters.alertWithout': 'Sem previsão vencida',
    'hospedagem.filters.observation': 'Observação',
    'hospedagem.filters.observationWith': 'Com observação em aberto',
    'hospedagem.filters.observationWithout': 'Sem observação em aberto',
    'hospedagem.filters.billing': 'Forma de cobrança',
    'hospedagem.filters.checkinFrom': 'Check-in de',
    'hospedagem.filters.checkinTo': 'Check-in até',
    'hospedagem.filters.checkoutFrom': 'Check-out de',
    'hospedagem.filters.checkoutTo': 'Check-out até',
    'hospedagem.filters.all': 'Todos',
    'hospedagem.filters.finishedOnly': 'Finalizados',
    'hospedagem.tipo.individual': 'Individual',
    'hospedagem.tipo.compartilhado': 'Compartilhado',
    'hospedagem.status.em_aberto': 'Em aberto',
    'hospedagem.status.inativo': 'Inativo',
    'hospedagem.status.finalizado': 'Finalizado',
    'hospedagem.status.hospedado': 'Hospedado',
    'hospedagem.status.checkout': 'Check-out',
    'hospedagem.billing.semanal': 'Semanal',
    'hospedagem.billing.quinzenal': 'Quinzenal',
    'hospedagem.billing.mensal': 'Mensal',
    'hospedagem.billing.final': 'No final da hospedagem',
    'hospedagem.table.name': 'Hotel',
    'hospedagem.table.city': 'Cidade',
    'hospedagem.table.defaultBilling': 'Cobrança padrão',
    'hospedagem.table.activeOperators': 'Operadores ativos',
    'hospedagem.table.openIndividual': 'Individuais em aberto',
    'hospedagem.table.openShared': 'Compartilhados em aberto',
    'hospedagem.table.lastIndividual': 'Último valor individual',
    'hospedagem.table.lastShared': 'Último valor compartilhado',
    'hospedagem.table.pending': 'Pendências',
    'hospedagem.table.pendingCheckout_one': '{{count}} quarto com previsão de check-out vencida',
    'hospedagem.table.pendingCheckout_other': '{{count}} quartos com previsão de check-out vencida',
    'hospedagem.table.pendingObservation_one': '{{count}} operador com observação em aberto',
    'hospedagem.table.pendingObservation_other': '{{count}} operadores com observação em aberto',
    'hospedagem.table.details': 'Ver detalhes',
    'hospedagem.detail.address': 'Endereço',
    'hospedagem.detail.contact': 'Contato',
    'hospedagem.detail.defaultBilling': 'Forma padrão de cobrança',
    'hospedagem.detail.billingNotes': 'Observações comerciais',
    'hospedagem.detail.back': 'Voltar para Hospedagem',
    'hospedagem.detail.editPlace': 'Editar local',
    'hospedagem.detail.configureBilling': 'Configurar cobrança',
    'hospedagem.detail.tabIndividual': 'Quartos individuais',
    'hospedagem.detail.tabShared': 'Compartilhados',
    'hospedagem.detail.newRecord': 'Novo registro',
    'hospedagem.detail.missingBilling': 'Configure a forma de cobrança do hotel para liberar a criação de registros.',
    'hospedagem.record.id': 'Identificação',
    'hospedagem.record.value': 'Valor negociado',
    'hospedagem.record.billing': 'Cobrança',
    'hospedagem.record.operator': 'Operador',
    'hospedagem.record.customer': 'Cliente',
    'hospedagem.record.checkin': 'Check-in',
    'hospedagem.record.checkout': 'Check-out',
    'hospedagem.record.openedAt': 'Abertura',
    'hospedagem.record.lastCheckout': 'Última saída',
    'hospedagem.record.occupants': 'Ocupantes',
    'hospedagem.record.customers': 'Clientes',
    'hospedagem.record.edit': 'Editar registro',
    'hospedagem.record.addOccupant': 'Adicionar operador',
    'hospedagem.record.editOccupant': 'Editar operador',
    'hospedagem.record.removeOccupant': 'Remover operador',
    'hospedagem.record.checkoutAction': 'Registrar check-out',
    'hospedagem.record.finalize': 'Finalizar quarto',
    'hospedagem.record.delete': 'Excluir quarto',
    'hospedagem.record.notes': 'Observação',
    'hospedagem.record.toggleOccupants': 'Mostrar operadores',
    'hospedagem.record.checkoutForecast': 'Previsão de check-out',
    'hospedagem.record.checkoutForecastHint': 'Opcional. Vencida, o quarto passa a alertar até ser finalizado ou a previsão ser alterada.',
    'hospedagem.record.checkoutForecastInvalid': 'A previsão não pode ser anterior à data de abertura.',
    'hospedagem.record.checkoutOverdueTooltip': 'Previsão de check-out vencida. Finalize o quarto ou altere a previsão.',
    'hospedagem.record.observationAdd': 'Adicionar observação',
    'hospedagem.record.observationActive': 'Observação em alerta',
    'hospedagem.record.observationCount_one': '{{count}} operador com observação em aberto',
    'hospedagem.record.observationCount_other': '{{count}} operadores com observação em aberto',
    'hospedagem.dialog.createTitle': 'Novo registro {{tipo}}',
    'hospedagem.dialog.editTitle': 'Editar {{id}}',
    'hospedagem.dialog.occupantTitle': 'Adicionar operador em {{id}}',
    'hospedagem.dialog.occupantEditTitle': 'Editar hospedagem de {{nome}}',
    'hospedagem.dialog.alreadyInRecord': 'Já está neste registro',
    'hospedagem.dialog.checkoutTitle': 'Registrar check-out',
    'hospedagem.dialog.checkoutConfirm': 'Confirmar o check-out de {{nome}} no registro {{id}}?',
    'hospedagem.dialog.finalizeTitle': 'Finalizar {{id}}',
    'hospedagem.dialog.finalizeConfirm': 'A data de finalização será a maior data de check-out. O registro ficará no histórico e não poderá mais ser alterado.',
    'hospedagem.dialog.finalizeBlocked': 'Há operadores sem check-out:',
    'hospedagem.dialog.billingTitle': 'Configuração de cobrança',
    'hospedagem.dialog.billingNotesPlaceholder': 'Data de fechamento, vencimento, proporcionalidade em saída antecipada e outras regras negociadas.',
    'hospedagem.dialog.billingSnapshotHint': 'A regra é copiada para cada novo registro na criação. Registros existentes não mudam.',
    'hospedagem.dialog.saving': 'Salvando…',
    'hospedagem.dialog.removeTitle': 'Remover operador',
    'hospedagem.dialog.removeConfirm': 'Remover {{nome}} do registro {{id}}? Use apenas para corrigir uma inclusão feita por engano.',
    'hospedagem.dialog.deleteRecordTitle': 'Excluir quarto contratado',
    'hospedagem.dialog.deleteRecordConfirm': 'Excluir {{id}} deste hotel? A contratação sai das listagens e a exclusão não é desfeita pela tela.',
    'hospedagem.dialog.deleteRecordOccupants_one': '{{count}} operador ainda está hospedado e fica liberado para nova hospedagem.',
    'hospedagem.dialog.deleteRecordOccupants_other': '{{count}} operadores ainda estão hospedados e ficam liberados para nova hospedagem.',
    'hospedagem.toast.recordCreated': 'Registro criado.',
    'hospedagem.toast.recordUpdated': 'Registro atualizado.',
    'hospedagem.toast.occupantAdded': 'Operador vinculado.',
    'hospedagem.toast.occupantUpdated': 'Hospedagem do operador atualizada.',
    'hospedagem.toast.occupantRemoved': 'Operador removido do registro.',
    'hospedagem.toast.checkoutDone': 'Check-out registrado.',
    'hospedagem.toast.finalized': 'Registro finalizado.',
    'hospedagem.toast.recordDeleted': 'Quarto excluído.',
    'hospedagem.toast.billingSaved': 'Configuração de cobrança salva.',
    'hospedagem.toast.observationOpened': 'Alerta de observação ativado.',
    'hospedagem.toast.observationResolved': 'Alerta de observação resolvido.',
    'hospedagem.empty.hotels': 'Nenhum hotel encontrado. Cadastre um local com a categoria Hotel para ele aparecer aqui.',
    'hospedagem.empty.individual': 'Nenhum registro individual neste hotel.',
    'hospedagem.empty.shared': 'Nenhum registro compartilhado neste hotel.',
    'hospedagem.empty.occupants': 'Nenhum operador vinculado a este registro.',
    'hospedagem.operatorSearch.placeholder': 'Buscar por nome ou matrícula…',
    'hospedagem.operatorSearch.matricula': 'Matrícula',
  },
  en: {
    'hospedagem.title': 'Lodging',
    'hospedagem.eyebrow': 'Journey',
    'hospedagem.kpi.hotels': 'Hotels',
    'hospedagem.kpi.activeOperators': 'Lodged operators',
    'hospedagem.kpi.openIndividual': 'Open individual rooms',
    'hospedagem.kpi.openShared': 'Open shared rooms',
    'hospedagem.kpi.checkoutAlerts': 'Overdue check-out forecasts',
    'hospedagem.kpi.openObservations': 'Open observations',
    'hospedagem.filters.toggle': 'Filters',
    'hospedagem.filters.clear': 'Clear',
    'hospedagem.filters.hotel': 'Hotel',
    'hospedagem.filters.city': 'City',
    'hospedagem.filters.operator': 'Operator',
    'hospedagem.filters.customer': 'Customer',
    'hospedagem.filters.roomType': 'Room type',
    'hospedagem.filters.roomStatus': 'Room status',
    'hospedagem.filters.hotelStatus': 'Hotel status',
    'hospedagem.filters.checkoutAlert': 'Check-out alert',
    'hospedagem.filters.alertWith': 'With overdue forecast',
    'hospedagem.filters.alertWithout': 'Without overdue forecast',
    'hospedagem.filters.observation': 'Observation',
    'hospedagem.filters.observationWith': 'With open observation',
    'hospedagem.filters.observationWithout': 'Without open observation',
    'hospedagem.filters.billing': 'Billing mode',
    'hospedagem.filters.checkinFrom': 'Check-in from',
    'hospedagem.filters.checkinTo': 'Check-in to',
    'hospedagem.filters.checkoutFrom': 'Check-out from',
    'hospedagem.filters.checkoutTo': 'Check-out to',
    'hospedagem.filters.all': 'All',
    'hospedagem.filters.finishedOnly': 'Finished',
    'hospedagem.tipo.individual': 'Individual',
    'hospedagem.tipo.compartilhado': 'Shared',
    'hospedagem.status.em_aberto': 'Open',
    'hospedagem.status.inativo': 'Inactive',
    'hospedagem.status.finalizado': 'Finished',
    'hospedagem.status.hospedado': 'Lodged',
    'hospedagem.status.checkout': 'Checked out',
    'hospedagem.billing.semanal': 'Weekly',
    'hospedagem.billing.quinzenal': 'Biweekly',
    'hospedagem.billing.mensal': 'Monthly',
    'hospedagem.billing.final': 'At the end of the stay',
    'hospedagem.table.name': 'Hotel',
    'hospedagem.table.city': 'City',
    'hospedagem.table.defaultBilling': 'Default billing',
    'hospedagem.table.activeOperators': 'Active operators',
    'hospedagem.table.openIndividual': 'Open individual',
    'hospedagem.table.openShared': 'Open shared',
    'hospedagem.table.lastIndividual': 'Last individual rate',
    'hospedagem.table.lastShared': 'Last shared rate',
    'hospedagem.table.pending': 'Pending',
    'hospedagem.table.pendingCheckout_one': '{{count}} room with an overdue check-out forecast',
    'hospedagem.table.pendingCheckout_other': '{{count}} rooms with an overdue check-out forecast',
    'hospedagem.table.pendingObservation_one': '{{count}} operator with an open observation',
    'hospedagem.table.pendingObservation_other': '{{count}} operators with an open observation',
    'hospedagem.table.details': 'View details',
    'hospedagem.detail.address': 'Address',
    'hospedagem.detail.contact': 'Contact',
    'hospedagem.detail.defaultBilling': 'Default billing mode',
    'hospedagem.detail.billingNotes': 'Commercial notes',
    'hospedagem.detail.back': 'Back to Lodging',
    'hospedagem.detail.editPlace': 'Edit place',
    'hospedagem.detail.configureBilling': 'Billing settings',
    'hospedagem.detail.tabIndividual': 'Individual rooms',
    'hospedagem.detail.tabShared': 'Shared rooms',
    'hospedagem.detail.newRecord': 'New record',
    'hospedagem.detail.missingBilling': 'Set the hotel billing mode to enable record creation.',
    'hospedagem.record.id': 'Identification',
    'hospedagem.record.value': 'Negotiated value',
    'hospedagem.record.billing': 'Billing',
    'hospedagem.record.operator': 'Operator',
    'hospedagem.record.customer': 'Customer',
    'hospedagem.record.checkin': 'Check-in',
    'hospedagem.record.checkout': 'Check-out',
    'hospedagem.record.openedAt': 'Opened',
    'hospedagem.record.lastCheckout': 'Last check-out',
    'hospedagem.record.occupants': 'Occupants',
    'hospedagem.record.customers': 'Customers',
    'hospedagem.record.edit': 'Edit record',
    'hospedagem.record.addOccupant': 'Add operator',
    'hospedagem.record.editOccupant': 'Edit operator',
    'hospedagem.record.removeOccupant': 'Remove operator',
    'hospedagem.record.checkoutAction': 'Register check-out',
    'hospedagem.record.finalize': 'Finish room',
    'hospedagem.record.delete': 'Delete room',
    'hospedagem.record.notes': 'Notes',
    'hospedagem.record.toggleOccupants': 'Show operators',
    'hospedagem.record.checkoutForecast': 'Check-out forecast',
    'hospedagem.record.checkoutForecastHint': 'Optional. Once overdue, the room keeps alerting until it is finished or the forecast is changed.',
    'hospedagem.record.checkoutForecastInvalid': 'The forecast cannot be earlier than the opening date.',
    'hospedagem.record.checkoutOverdueTooltip': 'Check-out forecast overdue. Finish the room or change the forecast.',
    'hospedagem.record.observationAdd': 'Add observation',
    'hospedagem.record.observationActive': 'Observation alert active',
    'hospedagem.record.observationCount_one': '{{count}} operator with an open observation',
    'hospedagem.record.observationCount_other': '{{count}} operators with an open observation',
    'hospedagem.dialog.createTitle': 'New {{tipo}} record',
    'hospedagem.dialog.editTitle': 'Edit {{id}}',
    'hospedagem.dialog.occupantTitle': 'Add operator to {{id}}',
    'hospedagem.dialog.occupantEditTitle': 'Edit stay of {{nome}}',
    'hospedagem.dialog.alreadyInRecord': 'Already in this record',
    'hospedagem.dialog.checkoutTitle': 'Register check-out',
    'hospedagem.dialog.checkoutConfirm': 'Confirm check-out of {{nome}} in record {{id}}?',
    'hospedagem.dialog.finalizeTitle': 'Finish {{id}}',
    'hospedagem.dialog.finalizeConfirm': 'The finish date will be the latest check-out date. The record stays in the history and can no longer be changed.',
    'hospedagem.dialog.finalizeBlocked': 'Some operators have no check-out yet:',
    'hospedagem.dialog.billingTitle': 'Billing settings',
    'hospedagem.dialog.billingNotesPlaceholder': 'Closing date, due date, proportional early check-out and other negotiated rules.',
    'hospedagem.dialog.billingSnapshotHint': 'The rule is copied into each new record at creation. Existing records do not change.',
    'hospedagem.dialog.saving': 'Saving…',
    'hospedagem.dialog.removeTitle': 'Remove operator',
    'hospedagem.dialog.removeConfirm': 'Remove {{nome}} from record {{id}}? Use only to fix a mistaken inclusion.',
    'hospedagem.dialog.deleteRecordTitle': 'Delete booked room',
    'hospedagem.dialog.deleteRecordConfirm': 'Delete {{id}} from this hotel? The booking leaves every listing and this screen cannot undo it.',
    'hospedagem.dialog.deleteRecordOccupants_one': '{{count}} operator is still checked in and becomes free for a new stay.',
    'hospedagem.dialog.deleteRecordOccupants_other': '{{count}} operators are still checked in and become free for a new stay.',
    'hospedagem.toast.recordCreated': 'Record created.',
    'hospedagem.toast.recordUpdated': 'Record updated.',
    'hospedagem.toast.occupantAdded': 'Operator linked.',
    'hospedagem.toast.occupantUpdated': 'Operator stay updated.',
    'hospedagem.toast.occupantRemoved': 'Operator removed from record.',
    'hospedagem.toast.checkoutDone': 'Check-out registered.',
    'hospedagem.toast.finalized': 'Record finished.',
    'hospedagem.toast.recordDeleted': 'Room deleted.',
    'hospedagem.toast.billingSaved': 'Billing settings saved.',
    'hospedagem.toast.observationOpened': 'Observation alert activated.',
    'hospedagem.toast.observationResolved': 'Observation alert resolved.',
    'hospedagem.empty.hotels': 'No hotels found. Register a place with the Hotel category to see it here.',
    'hospedagem.empty.individual': 'No individual records in this hotel.',
    'hospedagem.empty.shared': 'No shared records in this hotel.',
    'hospedagem.empty.occupants': 'No operator linked to this record.',
    'hospedagem.operatorSearch.placeholder': 'Search by name or employee id…',
    'hospedagem.operatorSearch.matricula': 'Employee id',
  },
  es: {
    'hospedagem.title': 'Hospedaje',
    'hospedagem.eyebrow': 'Jornada',
    'hospedagem.kpi.hotels': 'Hoteles',
    'hospedagem.kpi.activeOperators': 'Operadores hospedados',
    'hospedagem.kpi.openIndividual': 'Individuales abiertos',
    'hospedagem.kpi.openShared': 'Compartidos abiertos',
    'hospedagem.kpi.checkoutAlerts': 'Previsiones de check-out vencidas',
    'hospedagem.kpi.openObservations': 'Observaciones abiertas',
    'hospedagem.filters.toggle': 'Filtros',
    'hospedagem.filters.clear': 'Limpiar',
    'hospedagem.filters.hotel': 'Hotel',
    'hospedagem.filters.city': 'Ciudad',
    'hospedagem.filters.operator': 'Operador',
    'hospedagem.filters.customer': 'Cliente',
    'hospedagem.filters.roomType': 'Tipo de habitación',
    'hospedagem.filters.roomStatus': 'Estado de la habitación',
    'hospedagem.filters.hotelStatus': 'Estado del hotel',
    'hospedagem.filters.checkoutAlert': 'Alerta de check-out',
    'hospedagem.filters.alertWith': 'Con previsión vencida',
    'hospedagem.filters.alertWithout': 'Sin previsión vencida',
    'hospedagem.filters.observation': 'Observación',
    'hospedagem.filters.observationWith': 'Con observación abierta',
    'hospedagem.filters.observationWithout': 'Sin observación abierta',
    'hospedagem.filters.billing': 'Forma de cobro',
    'hospedagem.filters.checkinFrom': 'Check-in desde',
    'hospedagem.filters.checkinTo': 'Check-in hasta',
    'hospedagem.filters.checkoutFrom': 'Check-out desde',
    'hospedagem.filters.checkoutTo': 'Check-out hasta',
    'hospedagem.filters.all': 'Todos',
    'hospedagem.filters.finishedOnly': 'Finalizados',
    'hospedagem.tipo.individual': 'Individual',
    'hospedagem.tipo.compartilhado': 'Compartido',
    'hospedagem.status.em_aberto': 'Abierto',
    'hospedagem.status.inativo': 'Inactivo',
    'hospedagem.status.finalizado': 'Finalizado',
    'hospedagem.status.hospedado': 'Hospedado',
    'hospedagem.status.checkout': 'Check-out',
    'hospedagem.billing.semanal': 'Semanal',
    'hospedagem.billing.quinzenal': 'Quincenal',
    'hospedagem.billing.mensal': 'Mensual',
    'hospedagem.billing.final': 'Al final del hospedaje',
    'hospedagem.table.name': 'Hotel',
    'hospedagem.table.city': 'Ciudad',
    'hospedagem.table.defaultBilling': 'Cobro estándar',
    'hospedagem.table.activeOperators': 'Operadores activos',
    'hospedagem.table.openIndividual': 'Individuales abiertos',
    'hospedagem.table.openShared': 'Compartidos abiertos',
    'hospedagem.table.lastIndividual': 'Último valor individual',
    'hospedagem.table.lastShared': 'Último valor compartido',
    'hospedagem.table.pending': 'Pendientes',
    'hospedagem.table.pendingCheckout_one': '{{count}} habitación con previsión de check-out vencida',
    'hospedagem.table.pendingCheckout_other': '{{count}} habitaciones con previsión de check-out vencida',
    'hospedagem.table.pendingObservation_one': '{{count}} operador con observación abierta',
    'hospedagem.table.pendingObservation_other': '{{count}} operadores con observación abierta',
    'hospedagem.table.details': 'Ver detalles',
    'hospedagem.detail.address': 'Dirección',
    'hospedagem.detail.contact': 'Contacto',
    'hospedagem.detail.defaultBilling': 'Forma estándar de cobro',
    'hospedagem.detail.billingNotes': 'Notas comerciales',
    'hospedagem.detail.back': 'Volver a Hospedaje',
    'hospedagem.detail.editPlace': 'Editar lugar',
    'hospedagem.detail.configureBilling': 'Configurar cobro',
    'hospedagem.detail.tabIndividual': 'Habitaciones individuales',
    'hospedagem.detail.tabShared': 'Compartidas',
    'hospedagem.detail.newRecord': 'Nuevo registro',
    'hospedagem.detail.missingBilling': 'Configure la forma de cobro del hotel para habilitar la creación de registros.',
    'hospedagem.record.id': 'Identificación',
    'hospedagem.record.value': 'Valor negociado',
    'hospedagem.record.billing': 'Cobro',
    'hospedagem.record.operator': 'Operador',
    'hospedagem.record.customer': 'Cliente',
    'hospedagem.record.checkin': 'Check-in',
    'hospedagem.record.checkout': 'Check-out',
    'hospedagem.record.openedAt': 'Apertura',
    'hospedagem.record.lastCheckout': 'Última salida',
    'hospedagem.record.occupants': 'Ocupantes',
    'hospedagem.record.customers': 'Clientes',
    'hospedagem.record.edit': 'Editar registro',
    'hospedagem.record.addOccupant': 'Agregar operador',
    'hospedagem.record.editOccupant': 'Editar operador',
    'hospedagem.record.removeOccupant': 'Quitar operador',
    'hospedagem.record.checkoutAction': 'Registrar check-out',
    'hospedagem.record.finalize': 'Finalizar habitación',
    'hospedagem.record.delete': 'Eliminar habitación',
    'hospedagem.record.notes': 'Observación',
    'hospedagem.record.toggleOccupants': 'Mostrar operadores',
    'hospedagem.record.checkoutForecast': 'Previsión de check-out',
    'hospedagem.record.checkoutForecastHint': 'Opcional. Una vez vencida, la habitación sigue alertando hasta finalizarla o cambiar la previsión.',
    'hospedagem.record.checkoutForecastInvalid': 'La previsión no puede ser anterior a la fecha de apertura.',
    'hospedagem.record.checkoutOverdueTooltip': 'Previsión de check-out vencida. Finalice la habitación o cambie la previsión.',
    'hospedagem.record.observationAdd': 'Agregar observación',
    'hospedagem.record.observationActive': 'Observación en alerta',
    'hospedagem.record.observationCount_one': '{{count}} operador con observación abierta',
    'hospedagem.record.observationCount_other': '{{count}} operadores con observación abierta',
    'hospedagem.dialog.createTitle': 'Nuevo registro {{tipo}}',
    'hospedagem.dialog.editTitle': 'Editar {{id}}',
    'hospedagem.dialog.occupantTitle': 'Agregar operador en {{id}}',
    'hospedagem.dialog.occupantEditTitle': 'Editar hospedaje de {{nome}}',
    'hospedagem.dialog.alreadyInRecord': 'Ya está en este registro',
    'hospedagem.dialog.checkoutTitle': 'Registrar check-out',
    'hospedagem.dialog.checkoutConfirm': '¿Confirmar el check-out de {{nome}} en el registro {{id}}?',
    'hospedagem.dialog.finalizeTitle': 'Finalizar {{id}}',
    'hospedagem.dialog.finalizeConfirm': 'La fecha de finalización será la mayor fecha de check-out. El registro queda en el historial y ya no podrá modificarse.',
    'hospedagem.dialog.finalizeBlocked': 'Hay operadores sin check-out:',
    'hospedagem.dialog.billingTitle': 'Configuración de cobro',
    'hospedagem.dialog.billingNotesPlaceholder': 'Fecha de cierre, vencimiento, proporcionalidad por salida anticipada y otras reglas negociadas.',
    'hospedagem.dialog.billingSnapshotHint': 'La regla se copia en cada registro nuevo al crearlo. Los registros existentes no cambian.',
    'hospedagem.dialog.saving': 'Guardando…',
    'hospedagem.dialog.removeTitle': 'Quitar operador',
    'hospedagem.dialog.removeConfirm': '¿Quitar a {{nome}} del registro {{id}}? Úselo solo para corregir una inclusión errónea.',
    'hospedagem.dialog.deleteRecordTitle': 'Eliminar habitación contratada',
    'hospedagem.dialog.deleteRecordConfirm': '¿Eliminar {{id}} de este hotel? La contratación sale de los listados y la pantalla no deshace la eliminación.',
    'hospedagem.dialog.deleteRecordOccupants_one': '{{count}} operador sigue alojado y queda libre para un nuevo alojamiento.',
    'hospedagem.dialog.deleteRecordOccupants_other': '{{count}} operadores siguen alojados y quedan libres para un nuevo alojamiento.',
    'hospedagem.toast.recordCreated': 'Registro creado.',
    'hospedagem.toast.recordUpdated': 'Registro actualizado.',
    'hospedagem.toast.occupantAdded': 'Operador vinculado.',
    'hospedagem.toast.occupantUpdated': 'Hospedaje del operador actualizado.',
    'hospedagem.toast.occupantRemoved': 'Operador quitado del registro.',
    'hospedagem.toast.checkoutDone': 'Check-out registrado.',
    'hospedagem.toast.finalized': 'Registro finalizado.',
    'hospedagem.toast.recordDeleted': 'Habitación eliminada.',
    'hospedagem.toast.billingSaved': 'Configuración de cobro guardada.',
    'hospedagem.toast.observationOpened': 'Alerta de observación activada.',
    'hospedagem.toast.observationResolved': 'Alerta de observación resuelta.',
    'hospedagem.empty.hotels': 'Ningún hotel encontrado. Registre un lugar con la categoría Hotel para verlo aquí.',
    'hospedagem.empty.individual': 'Ningún registro individual en este hotel.',
    'hospedagem.empty.shared': 'Ningún registro compartido en este hotel.',
    'hospedagem.empty.occupants': 'Ningún operador vinculado a este registro.',
    'hospedagem.operatorSearch.placeholder': 'Buscar por nombre o matrícula…',
    'hospedagem.operatorSearch.matricula': 'Matrícula',
  },
}
